<template>
  <Card>
    <div slot="Title">Check on Learning</div>
    <div slot="Qs">
<p>Q: What does fund type designator F mean?</p>
<p>Q. What is the purpose of the Funded Program?</p>
<p>Q. What is the Appropriation Symbol for AO-2035 used to represent?</p>
    </div>
  </Card>
</template>

<style scoped>
.FundConceptWrapper {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.FundConceptWrapper > figure {
  max-width: calc(1406px / 2);
}

.FundConceptWrapper > figure > img {
  width: 80%;
  max-width: calc(1406px / 2);
  height: auto;
}
</style>
<script>
import Card from "../../../components/COL.vue";

export default {
  components: {
    Card
  },
  name: "FlowofFunds",

  data() {
    return {
    };
  }
};
</script>